// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { kaia as _kaia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the kaia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 8217
 * Chain Name: Kaia
 * Default Block Explorer: https://kaiascope.com
 * Default RPC URL: https://public-en.node.kaia.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { kaia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: kaia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const kaia = createCommon({
	..._kaia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
